import CheckoutMenu from './CheckoutMenu';

export default CheckoutMenu;
